module.exports = __webpack_public_path__ + "img/pr-54.d95a8a5a.png";